import { render } from "./App.vue?vue&type=template&id=032db33c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])